import { useLocation, useNavigate } from "react-router-dom"
import { useMutation, useQuery } from "@apollo/client/react";
import i18n from "../../i18n/i18n";
import { Box, MenuItem, useMediaQuery, useTheme, Button, Typography } from "@mui/material";
import Header from "../../components/PageHeader/header";
import { useTranslation } from "react-i18next";
import notify from "../../components/notify";
import { useFormik } from "formik";
import * as Yup from "yup";
import VerticalTextField, { SearchByTypingSelect, VerticalTextFieldSelect } from "../../components/Utilities/VerticalTextField";
import SubmitButton from "../../components/Utilities/SubmitButton";
import UploadFileField from "../../components/Utilities/UploadFileField";
import { useState, useRef } from "react";
import axios from "axios";
import { baseURL } from "../../Api/apolloClient";
import { CREATE_USER_BY_ADMIN } from "../../graphql/userQueriesForAdmin";
import { userRules } from "../../constants";
import { GET_GROUPS } from "../../graphql/groupQueries";
import { GET_ALL_FACULITIES } from "../../graphql/facultyQuiries";
import { GET_ACTIVE_JOB_TITLES } from "../../graphql/jobTitleQueries";
import logger from "../../utils/logger";


export default function AddUserPage() {
    const theme = useTheme();
    const { t } = useTranslation();
    const isArabic = i18n.language === "ar";
    const navigate = useNavigate();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const location = useLocation();

    const [selectedRule, setSelectedRule] = useState(0);
    const signatureInputRef = useRef(null);
    const [selectedToShowSignature, setSelectedToShowSignature] = useState("");
    const [uploadingSignature, setUploadingSignature] = useState(false);

  const { data, loading, error } = useQuery(GET_GROUPS, {
    fetchPolicy: "network-only",
  });

  const { data: facultiesData } = useQuery(GET_ALL_FACULITIES, {
    fetchPolicy: "network-only",
  });

  const { data: jobTitlesData } = useQuery(GET_ACTIVE_JOB_TITLES, {
    fetchPolicy: "network-only",
  });

    const [
        CreateUser,
        {
            loading: CreateUserLoading
        }
    ] = useMutation(CREATE_USER_BY_ADMIN, { fetchPolicy: "network-only" });

    const handleSignatureFileChange = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        setSelectedToShowSignature(file.name);
        const formData = new FormData();
        formData.append("file", file);
        setUploadingSignature(true);
        try {
            let uploadedUrl = "";
            try {
                const res = await axios.post(`${baseURL}/api/users/single`, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
                uploadedUrl = res?.data?.url || res?.data?.path;
            } catch (err1) {
                const res = await axios.post(`${baseURL}/api/forms/single`, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
                uploadedUrl = res?.data?.url || res?.data?.path;
            }
            if (uploadedUrl) {
                formik.setFieldValue("signature", uploadedUrl);
                notify(isArabic ? "تم رفع صورة التوقيع بنجاح" : "Signature uploaded successfully", "success");
            } else {
                notify(isArabic ? "فشل رفع صورة التوقيع" : "Failed to upload signature", "error");
            }
        } catch (err) {
            notify(isArabic ? "فشل رفع صورة التوقيع" : "Failed to upload signature", "error");
        } finally {
            setUploadingSignature(false);
        }
    };

    const formik = useFormik({
        initialValues: {
            username: "",
            fullname: "",
            email: "",
            mobile: "",
            password:"",
            groupIds: [],
            faculty_id: "",
            job_title_id: "",
            signature: "",
        },

        validationSchema: Yup.object({
            selectedRule: selectedRule == 0 && Yup.string()
                .required(t("admissions.errors.required"))
                .notOneOf(["0"], t("admissions.errors.required")),
            username: Yup.string().required(t("admissions.errors.required")),
            fullname: Yup.string().required(t("admissions.errors.required")),
            email: Yup.string().email(t("admissions.errors.invalidEmail"))
            .required(t("admissions.errors.required")),
            mobile: Yup.string().required(t("admissions.errors.required")),
            groupIds: Yup.array().min(1, t("admissions.errors.required")).required(t("admissions.errors.required")),

        }),
   
        onSubmit: async (values) => {
    let data = {
        username: values?.username,
        fullname: values?.fullname,
        email: values?.email,
        mobile: values?.mobile,
        password: values?.password,
        groups: values.groupIds,
    };
    if (values.faculty_id) {
        data.faculty_id = values.faculty_id;
    }
    if (values.job_title_id) {
        data.job_title_id = values.job_title_id;
    }
    if (values.signature) {
        data.signature = values.signature;
    }
    data.role = selectedRule;

    try {
        const result = await CreateUser({
            variables: { input: data }
        });
        notify(t("success"), "success");
        navigate(location.pathname.split('/add')[0]);
    } catch (error) {
        logger.error("Error:", error);
        // أضف رسالة الخطأ الفعلية
        const errorMessage = error?.graphQLErrors?.[0]?.message 
            || error?.message 
            || t("error");
        notify(errorMessage, "error");
    }
},

    });

    const groupsOptions = data?.groups || [];
    const facultiesOptions = facultiesData?.faculties || [];
    const jobTitlesOptions = jobTitlesData?.getActiveJobTitles || [];
    
    let translateText = isArabic ? "مستخدم" : "User";
    let translateText2 = isArabic ? "المستخدم" : "User";

    let userRulesWithOutStudent=userRules;
    // let userRulesWithOutStudent=userRules.filter(item=>item!="student");
    return (
        <Box sx={{ p: 3, backgroundColor: "background.paper" }}>
            <Header
                title={t("Users")}
                subtitle={t("addItem", { item: translateText })}
                i18n={i18n}
                haveBtn={false}
                hasAddOrEditBtn={true}
                sub2={t("addItem", { item: translateText })}
                hasNavigate={true}
                isExcel={false}
                isPdf={false}
                isPrinter={false}
            />
            <Box
                onSubmit={formik.handleSubmit}
                // sx={{ width: isMobile ? "90%" : "100%" }}
                component="form">

                <VerticalTextField
                    title={t("Dashboard.userName", { item: translateText2 })}
                    fieldID={"username"}
                    fieldName={"username"}
                    placeholder={t("Dashboard.userName", { item: translateText2 })}
                    value={formik.values.username}
                    onChange={formik.handleChange}
                    error={formik.touched.username && Boolean(formik.errors.username)}
                    helperText={formik.touched.username && formik.errors.username}
                />

                <VerticalTextField
                    title={t("admissions.fullName", { item: translateText2 })}
                    fieldID={"fullname"}
                    fieldName={"fullname"}
                    placeholder={t("admissions.fullName", { item: translateText2 })}
                    value={formik.values.fullname}
                    onChange={formik.handleChange}
                    error={formik.touched.fullname && Boolean(formik.errors.fullname)}
                    helperText={formik.touched.fullname && formik.errors.fullname}
                />

                <VerticalTextField
                    title={t("admissions.email", { item: translateText2 })}
                    fieldID={"email"}
                    fieldName={"email"}
                    placeholder={t("admissions.email", { item: translateText2 })}
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                />

                <VerticalTextField
                    title={t("Mobile", { item: translateText2 })}
                    fieldID={"mobile"}
                    fieldName={"mobile"}
                    placeholder={t("Mobile", { item: translateText2 })}
                    value={formik.values.mobile}
                    onChange={formik.handleChange}
                    error={formik.touched.mobile && Boolean(formik.errors.mobile)}
                    helperText={formik.touched.mobile && formik.errors.mobile}
                />

                 <VerticalTextField
                    title={t("form.password", { item: translateText2 })}
                    fieldID={"password"}
                    fieldName={"password"}
                    placeholder={t("form.password", { item: translateText2 })}
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    error={formik.touched.password && Boolean(formik.errors.password)}
                    helperText={formik.touched.password && formik.errors.password}
                />

                <VerticalTextFieldSelect
                    t={t}
                    title={t("Dashboard.userType")} defaultOptionLabel={t("select")}
                    backgroundColor={theme.palette.background.inputBackGround}
                    value={selectedRule}
                    setValue={setSelectedRule}
                    onBlur={(e) => {
                        if (selectedRule != 0) formik.setFieldError("selectedRule", undefined);

                    }}
                    error={formik.errors.selectedRule && t("admissions.errors.required")}
                    helperText={formik.errors.selectedRule && t("admissions.errors.required")}
                >
                    <MenuItem value={0} selected>{t("select")}</MenuItem>
                    {
                        userRulesWithOutStudent?.map((el, i) => <MenuItem key={i} value={el}>{t(`Dashboard.${el}`)}</MenuItem>)
                    }
                </VerticalTextFieldSelect>
<SearchByTypingSelect
    title={t("Groups")}
    options={groupsOptions}
    multiple={true} // Enable multi-select
    findKey="id"    // The key in the object to store (groups)
    labelToShow={(option) => (isArabic ? option.name_ar : option.name_en)}
    value={formik.values.groupIds}
    setValue={(newIds) => formik.setFieldValue("groupIds", newIds)}
    onBlur={() => formik.setFieldTouched("groupIds", true)}
    error={formik.touched.groupIds && formik.errors.groupIds}
/>

<SearchByTypingSelect
    title={t("admissions .faculty")}
    options={facultiesOptions}
    multiple={false} 
    findKey="id"    
    labelToShow={(option) => (isArabic ? option.title_ar : option.title_en)}
    value={formik.values.faculty_id}
    setValue={(newId) => formik.setFieldValue("faculty_id", newId)}
    onBlur={() => formik.setFieldTouched("faculty_id", true)}
    error={formik.touched.faculty_id && formik.errors.faculty_id}
/>

<SearchByTypingSelect
    title={isArabic ? "المسمى الوظيفي" : "Job Title"}
    options={jobTitlesOptions}
    multiple={false}
    findKey="id"
    labelToShow={(option) => (isArabic ? option.name_ar : option.name_en)}
    value={formik.values.job_title_id}
    setValue={(newId) => formik.setFieldValue("job_title_id", newId)}
    onBlur={() => formik.setFieldTouched("job_title_id", true)}
    error={formik.touched.job_title_id && formik.errors.job_title_id}
/>

<Box sx={{ my: 2 }}>
    <UploadFileField
        title={isArabic ? "صورة التوقيع" : "Signature Image"}
        subTitle={isArabic ? "رفع توقيع الموظف" : "Upload Signature"}
        fileInputRef={signatureInputRef}
        handleFileChange={handleSignatureFileChange}
        handlePickFile={() => signatureInputRef.current?.click()}
        selectedToShowFile={selectedToShowSignature}
        progress={uploadingSignature ? 50 : 0}
        showInput={true}
    />
    {formik.values.signature && (
        <Box sx={{ mt: 1.5, display: "flex", alignItems: "center", gap: 2 }}>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {isArabic ? "معاينة التوقيع:" : "Signature Preview:"}
            </Typography>
            <Box
                component="img"
                src={
                    formik.values.signature.startsWith("http")
                        ? formik.values.signature
                        : `${baseURL}${formik.values.signature.startsWith("/") ? "" : "/"}${formik.values.signature}`
                }
                alt="Signature Preview"
                sx={{
                    maxHeight: 50,
                    maxWidth: 130,
                    border: "1px solid #ccc",
                    borderRadius: 1,
                    p: 0.5,
                    backgroundColor: "#fff",
                    boxShadow: 1,
                }}
            />
            <Button
                size="small"
                color="error"
                variant="outlined"
                onClick={() => {
                    formik.setFieldValue("signature", "");
                    setSelectedToShowSignature("");
                }}
            >
                {isArabic ? "إزالة التوقيع" : "Remove Signature"}
            </Button>
        </Box>
    )}
</Box>

                <SubmitButton loading={CreateUserLoading || uploadingSignature} t={t} />
            </Box>
        </Box>
    )
}
